import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const CHARACTER_ENDPOINT = 'api/v1/admin/characters';

function searchCharacters(params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}`, params);
}

function getCharacterDetail(characterId: string) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}`, {});
}


function getCharacterOutfits(characterId: string, params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits`, params);
}

function getCharacterOutfitItemsByCharacterId(characterId: string, params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfitItems`, params);
}

function getCharacterOutfitDetail(characterId: string, outfitId: string) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}`, {});
}

function createCharacterOutfit(characterId: string, data: any) {
    return api.createWithFile(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits`, data);
}

function updateCharacterOutfit(characterId: string, outfitId: string, data: any) {
    return api.updateWithFilePut(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}`, data);
}

function deleteCharacterOutfit(characterId: string, outfitId: string) {
    return api.delete(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}`);
}

function generateCharacterOutfitItems(characterId: string, outfitId: string, data: any) {
    return api.create(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}/gen_items`, data);
}

function getCharacterOutfitItems(characterId: string, outfitId: string, params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}/items`, params);
}

function getCharacterOutfitItemDetail(characterId: string, outfitId: string, itemId: string) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}/items/${itemId}`, {});
}

function createCharacterOutfitItem(characterId: string, outfitId: string, data: any) {
    return api.createWithFile(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}/items`, data);
}

function updateCharacterOutfitItem(characterId: string, outfitId: string, itemId: string, data: any) {
    return api.updateWithFilePut(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}/items/${itemId}`, data);
}

function deleteCharacterOutfitItem(characterId: string, outfitId: string, itemId: string) {
    return api.delete(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/outfits/${outfitId}/items/${itemId}`);
}


//sound
function getCharacterSounds(characterId: string, params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/sounds`, params);
}

function createCharacterSound(characterId: string, data: any) {
    return api.createWithFile(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/sounds`, data);
}

function getCharacterSoundDetail(characterId: string, soundId: string) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/sounds/${soundId}`, {});
}

function updateCharacterSound(characterId: string, soundId: string, data: any) {
    return api.updateWithFilePut(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/sounds/${soundId}`, data);
}

function deleteCharacterSound(characterId: string, soundId: string) {
    return api.delete(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/sounds/${soundId}`);
}

// video
function getCharacterVideos(characterId: string, params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/videos`, params);
}

function createCharacterVideo(characterId: string, data: any) {
    return api.createWithFile(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/videos`, data);
}

function getCharacterVideoDetail(characterId: string, videoId: string) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/videos/${videoId}`, {});
}

function updateCharacterVideo(characterId: string, videoId: string, data: any) {
    return api.updateWithFilePut(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/videos/${videoId}`, data);
}

function deleteCharacterVideo(characterId: string, videoId: string) {
    return api.delete(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/videos/${videoId}`);
}

export {
    searchCharacters,
    getCharacterDetail,
    getCharacterOutfits,
    getCharacterOutfitDetail,
    deleteCharacterOutfit,
    createCharacterOutfit,
    updateCharacterOutfit,
    getCharacterSounds,
    createCharacterSound,
    getCharacterSoundDetail,
    updateCharacterSound,
    deleteCharacterSound,
    getCharacterVideos,
    createCharacterVideo,
    getCharacterVideoDetail,
    updateCharacterVideo,
    deleteCharacterVideo,
    getCharacterOutfitItems,
    getCharacterOutfitItemDetail,
    updateCharacterOutfitItem,
    generateCharacterOutfitItems,
    getCharacterOutfitItemsByCharacterId,
    deleteCharacterOutfitItem,
    createCharacterOutfitItem
}




